export var Purpose;
(function (Purpose) {
    Purpose["NewPurchase"] = "NEW_PURCHASE";
    Purpose["Refinance"] = "REFINANCE";
})(Purpose || (Purpose = {}));
//# sourceMappingURL=index.js.map